var lightmapAddPS = `
void addLightMap() {
		dDiffuseLight += dLightmap;
}
`;

export { lightmapAddPS as default };
